// @flow

import { backendAxios } from './axios-config';
import isEmpty from 'lodash/isEmpty';

import type { Moment } from 'moment';

import CustomError from '../utils/error';
import { dateToString } from '../utils/date';

const { REACT_APP_WB_BACKEND_URL } = process.env;

const getBenchmarking = (policyId: string, dateAsAt: Moment) => {
  if (isEmpty(REACT_APP_WB_BACKEND_URL)) throw new CustomError('Empty URL');

  const params = { date: dateToString(dateAsAt) };

  return backendAxios.get(`/policies/${policyId}/funds/benchmarking`, {
    params,
  });
};

export default getBenchmarking;
